import { Model } from '@shared-features/models/model';
import { Expose, Type } from 'class-transformer';
import { Shipment } from '@shared-features/models/shipment';
import { Truck } from '@features/fleets/models';
import { User } from '@features/users/models/user';
import { AssignmentRequestStatus } from '@features/shipments/enums/assignment-request-status.enum';

export class AssignmentRequest extends Model {
  @Expose()
  id: number;
  @Expose()
  truckPlateNumber: string;
  @Expose()
  rejectionReason: string;
  @Expose()
  status: AssignmentRequestStatus;

  @Expose()
  isLatestAction: boolean;

  @Expose()
  @Type(() => Shipment)
  shipment: Shipment;

  @Expose()
  @Type(() => Truck)
  truck: Truck;

  @Expose()
  @Type(() => User)
  createdBy: User;

  @Expose()
  createdAt: Date;
}
